import type { Event } from 'lumen/models';
import { EVENTS_STATUSES } from 'lumen/models/event';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function filterEvents(
  events: Event[],
  selectedEventsStatuses: string[],
  selectedEventsCategories: string[],
) {
  if (events) {
    return events.filter((event) => {
      const matchesFilter = selectedEventsStatuses.some((filter) => {
        if (filter === EVENTS_STATUSES.DECLINED) {
          return event.isDeclined;
        }
        if (filter === EVENTS_STATUSES.SUGGESTED) {
          return event.importance >= 1 && event.status === '';
        }
        if (filter === EVENTS_STATUSES.ACCEPTED) {
          return event.isAccepted;
        }
        return false;
      });

      const matchesCategory = selectedEventsCategories.includes(event.category);

      return matchesFilter && matchesCategory;
    });
  }

  return [];
}
